import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FrameToComeService } from '@app/core/services';
import { CreateShippingLabelComponent } from '../create-shipping-label/create-shipping-label.component';
import { GeneratedLabelComponent } from '../generated-label/generated-label.component';
import { Store } from '@ngrx/store';
import { FrameToComeActionTypes } from '@app/core/ngrx';

@Component({
  selector: 'ecp-frame-shipment-details',
  templateUrl: './frame-shipment-details.component.html',
  styleUrls: ['./frame-shipment-details.component.scss'],
})
export class FrameShipmentDetailsComponent implements OnInit {
  @Input() framesInfo: any;
  @Input() framesIndex: any;
  @Input() labLocations: any;
  printLoading: boolean = false;
  errorMessage: boolean = false;
  constructor(private frameToCome: FrameToComeService, public dialog: MatDialog, public store: Store) {}

  ngOnInit(): void {}
  printLabel(trackingNumber: string, cartId: string = null) {
    this.printLoading = true;
    this.frameToCome.getShippingLabelFile(trackingNumber).subscribe(
      label => {
        this.printLoading = false;
        if (label) {
          const printContents = document.getElementById(cartId)?.innerHTML;
          let imageFile = 'data:image/png;base64,' + label.labelBinary;
          const newWindow = window.open();
          newWindow.document.write(
            `<html><head><title>${trackingNumber}</title>
          <style>table{width:100%; font-family:Arial, Helvetica, sans-serif;} table,tr,td,th{border:solid 1px #000; border-collapse: collapse;} td,th{padding:10px 5px 0px 5px}
          @media print{
          .packingList{
            break-after: page;
            }
          }
          </style></head><body>
          <div class="packingList">
            <h1>Priority</h1>
            <img src="${imageFile}" style="transform:rotate(90deg);margin-top:30%;width:100%" onload="window.print();window.close();" />
          </div>
          ${printContents}
          </body></html>`,
          );
          newWindow.document.close();
        }
        this.errorMessage = false;
      },
      err => {
        this.printLoading = false;
        this.errorMessage = true;
      },
    );
  }
  createShippingLabel(cartOrder: any) {
    let shippingData = {
      labLocation: this.labLocations,
      selectedLab: cartOrder,
    };
    let shippingDialog = this.dialog.open(CreateShippingLabelComponent, {
      width: '600px',
      maxWidth: '89.3vw',
      maxHeight: '82vh',
      data: shippingData,
      disableClose: true,
    });
    shippingDialog.afterClosed().subscribe((result: any) => {
      if (result) {
        let generatePayload = { ...result, cartId: cartOrder.cartId };
        this.generateLabelService(generatePayload);
      }
    });
  }
  generateLabelService(pl: any = null) {
    let generateDialog = this.dialog
      .open(GeneratedLabelComponent, {
        width: '600px',
        maxWidth: '89.3vw',
        height: '80%',
        data: pl,
        disableClose: true,
      })
      .afterClosed()
      .subscribe((gen: any) => {
        if (gen) {
          this.store.dispatch({
            type: FrameToComeActionTypes.LOAD_FRAME_TO_COME_ORDERS,
          });
        }
      });
  }
  printPackingList(cartId: string) {
    const printContents = document.getElementById(cartId)?.innerHTML;
    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
        <html>
          <head>
            <title>Packing Slip </title>
            <style>table{width:100%; font-family:Arial, Helvetica, sans-serif;} table,tr,td,th{border:solid 1px #000; border-collapse: collapse;} td,th{padding:10px 5px 0px 5px}</style>
          </head>
          <body onload="window.print();window.close()">
            ${printContents}
          </body>
        </html>
      `);
      popupWin.document.close();
    }
  }
}
